import { defaultStatus } from '../../data/refData.js';
import { convertArrayToLines } from '../../functions.js';

// return a fully populated faq record, amalgamating with any existing data provided via 'currentData'

export const faqRecord = (currentData = {}, mode) => {
  const record = {
    _mode           : mode,
    faq_answer      : [],
    ...currentData,
    ...(mode === 'create') && {
      _id        : null,
      faq_status : defaultStatus(),
    },
  };
  record.faq_answer = convertArrayToLines(record.faq_answer);
  return record;
};
